<template>
  <div class="acoes-page-root w-100">
    <div class="show-main-content">
      <!-- Plan Header (when strategicPlan) -->
      <div v-if="strategicPlan" class="plan-header-card">
          <div class="d-flex plan-header-top">
            <div class="d-flex align-items-start plan-header-left">
              <div class="plan-icon-wrap mr-3">
                <font-awesome-icon :icon="planIcon" class="plan-icon" />
              </div>
              <div class="plan-header-title-area">
                <h1 class="plan-title">{{ strategicPlan.name || 'Plano Estratégico' }}</h1>
              </div>
            </div>

            <div class="plan-meta-grid plan-meta-grid-desktop">
              <div class="plan-meta-item">
                <span class="plan-meta-label">Responsável</span>
                <p class="plan-meta-value">
                  <font-awesome-icon :icon="['fas', 'user']" class="plan-meta-icon" />
                  {{ planResponsibleText }}
                </p>
              </div>
              <div class="plan-meta-item">
                <span class="plan-meta-label">Vigência</span>
                <p class="plan-meta-value">
                  <font-awesome-icon :icon="['fas', 'calendar']" class="plan-meta-icon" />
                  {{ planVigenciaText }}
                </p>
              </div>
              <div v-if="hasPlanInstrumentoLegal" class="plan-meta-item">
                <span class="plan-meta-label">Instrumento Legal</span>
                <p class="plan-meta-value">
                  <font-awesome-icon :icon="['fas', 'file-alt']" class="plan-meta-icon" />
                  {{ planInstrumentoText }}
                </p>
              </div>
              <div class="plan-meta-item">
                <span class="plan-meta-label">Última Atualização</span>
                <p class="plan-meta-value">
                  <font-awesome-icon :icon="['fas', 'clock']" class="plan-meta-icon" />
                  {{ planLastUpdateText }}
                </p>
              </div>
            </div>

          </div>

          <div class="plan-meta-grid-mobile">
            <div class="plan-meta-item">
              <span class="plan-meta-label">Responsável</span>
              <p class="plan-meta-value">
                <font-awesome-icon :icon="['fas', 'user']" class="plan-meta-icon" />
                {{ planResponsibleText }}
              </p>
            </div>
            <div class="plan-meta-item">
              <span class="plan-meta-label">Vigência</span>
              <p class="plan-meta-value">
                <font-awesome-icon :icon="['fas', 'calendar']" class="plan-meta-icon" />
                {{ planVigenciaText }}
              </p>
            </div>
            <div v-if="hasPlanInstrumentoLegal" class="plan-meta-item">
              <span class="plan-meta-label">Instrumento Legal</span>
              <p class="plan-meta-value">
                <font-awesome-icon :icon="['fas', 'file-alt']" class="plan-meta-icon" />
                {{ planInstrumentoText }}
              </p>
            </div>
            <div class="plan-meta-item">
              <span class="plan-meta-label">Última Atualização</span>
              <p class="plan-meta-value">
                <font-awesome-icon :icon="['fas', 'clock']" class="plan-meta-icon" />
                {{ planLastUpdateText }}
              </p>
            </div>
          </div>

          <div class="plan-header-actions">
            <router-link
              :to="{ name: 'strategic_plans_edit', params: { id: strategicPlan.id } }"
              class="btn-plan-edit"
            >
              <font-awesome-icon :icon="['fas', 'pencil-alt']" class="mr-1" />
              Editar
            </router-link>
          </div>
        </div>

      <!-- Tab navigation (shown when in plan context or always for consistency) -->
      <PlanStructureTabs
        active-tab="acoes"
        :structure-detail="structureDetailText"
        :action-badges="actionBadges"
        :strategic-plan-id="strategicPlanId || undefined"
      />

      <!-- Tree panel (search + actions list) -->
      <div class="tree-panel">
          <!-- Toolbar: search -->
          <div class="tree-toolbar mb-3">
            <div class="search-wrap search-wrap-inline">
              <span class="search-icon">
                <font-awesome-icon :icon="['fas', 'search']" />
              </span>
              <input
                v-model="search"
                class="search-input"
                type="text"
                placeholder="Buscar por nome, plano, projeto ou responsável..."
              />
            </div>
          </div>

          <div class="acoes-main">
      <div class="sort-bar d-flex align-items-center flex-wrap">
        <div class="label text-xs font-semibold text-muted-foreground uppercase tracking-wider mr-2">
          Ordenar:
        </div>

        <button
          type="button"
          class="pill"
          :class="sortKey === 'prazo' ? 'pill-active' : 'pill-inactive'"
          @click="toggleSort('prazo')"
        >
          Prazo
          <font-awesome-icon :icon="['fas', 'sort']" class="icon-sort ml-1" />
        </button>

        <button
          type="button"
          class="pill"
          :class="sortKey === 'status' ? 'pill-active' : 'pill-inactive'"
          @click="toggleSort('status')"
        >
          Status
          <font-awesome-icon :icon="['fas', 'sort']" class="icon-sort ml-1" />
        </button>

        <button
          type="button"
          class="pill"
          :class="sortKey === 'orcamento' ? 'pill-active' : 'pill-inactive'"
          @click="toggleSort('orcamento')"
        >
          Orçamento
          <font-awesome-icon :icon="['fas', 'sort']" class="icon-sort ml-1" />
        </button>

        <div class="ml-auto count text-xs text-muted-foreground font-medium">
          {{ filteredSorted.length }} ações
        </div>
      </div>

      <div class="filter-bar">
        <div class="filter-bar-inner d-flex align-items-center flex-wrap">
          <div class="filter-group">
            <label class="filter-label">Cronograma</label>
            <div class="d-flex align-items-center" style="gap: 8px;">
              <span class="text-xs text-muted-foreground">De</span>
              <input v-model="prazoInicio" type="date" class="filter-input" />
            </div>
          </div>
          <div class="filter-group">
            <label class="filter-label">&nbsp;</label>
            <div class="d-flex align-items-center" style="gap: 8px;">
              <span class="text-xs text-muted-foreground">Até</span>
              <input v-model="prazoFim" type="date" class="filter-input" />
            </div>
          </div>

          <div class="filter-divider" />

          <div class="filter-group">
            <label class="filter-label">Status</label>
            <select v-model="filtroStatus" class="filter-select filter-select-status">
              <option value="todos">Todos</option>
              <option value="waiting">Aguardando</option>
              <option value="planned">Planejado</option>
              <option value="in-progress">Em progresso</option>
              <option value="delayed">Atrasado</option>
              <option value="stopped">Paralizado</option>
              <option value="cancelled">Cancelado</option>
              <option value="finished">Finalizado</option>
            </select>
          </div>

          <div class="filter-divider" />

          <div class="filter-group">
            <label class="filter-label">Orçamento</label>
            <select v-model="filtroOrcamento" class="filter-select filter-select-orcamento">
              <option value="todos">Todos</option>
              <option value="sem">Sem orçamento</option>
              <option value="dentro">Dentro do orçamento</option>
              <option value="excedeu">Excedeu o orçamento</option>
            </select>
          </div>

          <div class="filter-divider" />

          <div class="filter-group filter-group-responsavel">
            <label class="filter-label">Responsável</label>
            <select v-model="filtroResponsavel" class="filter-select filter-select-responsavel">
              <option value="todos">Todos</option>
              <option value="sem_responsavel">Sem responsável</option>
              <option v-for="resp in responsaveisUnicos" :key="resp.id" :value="resp.name">
                {{ resp.name }}
              </option>
            </select>
          </div>

          <button
            v-if="hasActiveFilters"
            type="button"
            class="btn-clear-filters ml-auto"
            @click="clearFilters"
          >
            ✕ Limpar filtros
          </button>
        </div>
      </div>

      <div v-if="loading" class="py-4 text-muted-foreground">Carregando...</div>
      <div v-else-if="error" class="py-4 text-danger">{{ error }}</div>
      <div v-else-if="filteredSorted.length === 0" class="empty-state">
        <div class="text-center">
          <div class="h6 font-weight-medium mb-1">Nenhuma ação encontrada</div>
          <div class="text-sm text-muted-foreground">
            Ajuste os filtros ou faça uma nova busca.
          </div>
        </div>
      </div>
      <div v-else class="cards space-y-3">
        <article v-for="action in paginated" :key="action.id" class="action-card" :class="{ 'action-card--sub': !!action.parent_id }">
          <div v-if="action.parent_id" class="sub-action-corner parent-action-wrap">
            <span class="parent-action-label">
              <font-awesome-icon :icon="['fas', 'level-up-alt']" class="sub-action-corner-icon" />
              Ação pai: {{ parentActionName(action) }}
            </span>
            <button
              v-if="parentAction(action)"
              type="button"
              class="parent-action-edit-btn"
              title="Editar ação pai"
              @click.stop="goToEdit(parentAction(action))"
            >
              <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            </button>
          </div>
          <div class="p-5">
            <div class="d-flex align-items-start justify-content-between mb-4" style="gap: 16px;">
              <div class="min-w-0 flex-1 d-flex align-items-start" style="gap: 10px;">
                <span class="status-dot flex-shrink-0 mt-1" :class="statusDotClass(action)" />
                <div class="min-w-0 flex-1">
                  <div class="text-sm font-bold text-foreground text-truncate">
                    {{ action.what || 'Ação' }}
                  </div>
                  <div class="breadcrumb text-xs text-muted-foreground mt-1">
                    {{ breadcrumbText(action) }}
                  </div>
                </div>
              </div>

              <div class="status-badge" :class="statusBadgeClass(action)">
                <span>{{ statusLabel(action) }}</span>
              </div>
            </div>

            <div class="indicators">
              <div class="indicator">
                <div class="indicator-label">
                  <font-awesome-icon :icon="['fas', 'check-square']" class="icon-12" />
                  PROGRESSO
                </div>
                <div class="d-flex align-items-center">
                  <div class="progress-bar">
                    <div class="progress-inner" :class="progressClass(action)" :style="{ width: completude(action) + '%' }" />
                  </div>
                  <div class="percent text-xs font-bold text-foreground">{{ completude(action) }}%</div>
                </div>
              </div>

              <div class="indicator">
                <div class="indicator-label">
                  <font-awesome-icon :icon="['fas', 'dollar-sign']" class="icon-12" />
                  ORÇAMENTO
                </div>
                <div class="text-xs font-semibold text-foreground">
                  {{ formatCurrency(budgetExecuted(action)) }}
                  <span class="text-muted-foreground font-normal">
                    / {{ formatCurrency(budgetPlanned(action)) }}
                  </span>
                </div>
                <div class="budget-pill" :class="budgetPillClass(action)">
                  <font-awesome-icon :icon="budgetPillIcon(action)" class="icon-10" />
                  <span>{{ budgetPillLabel(action) }}</span>
                </div>
              </div>

              <div class="indicator">
                <div class="indicator-label">
                  <font-awesome-icon :icon="['fas', 'calendar']" class="icon-12" />
                  CRONOGRAMA
                </div>
                <div class="schedule-pill" :class="schedulePillClass(action)">
                  <font-awesome-icon
                    v-if="isScheduleLate(action)"
                    :icon="['fas', 'exclamation-triangle']"
                    class="icon-10"
                  />
                  <span>{{ scheduleLabel(action) }}</span>
                </div>
              </div>

              <div class="indicator indicator--responsible">
                <div class="indicator-label">
                  <font-awesome-icon :icon="responsibleIcon(action)" class="icon-12" />
                  RESPONSÁVEL
                </div>
                <div class="indicator-responsible-name text-xs font-semibold text-foreground">
                  {{ responsibleName(action) }}
                </div>
                <div class="indicator-responsible-type text-10 text-muted-foreground">
                  {{ responsibleTypeLabel(action) }}
                </div>
              </div>
            </div>
          </div>

          <div class="quick-actions">
            <button type="button" class="qa-btn" @click="goToEdit(action)">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" class="icon-14" />
              Editar
            </button>
          </div>
        </article>
      </div>

      <div v-if="totalPages > 1" class="pagination pt-4">
        <button type="button" class="page-nav" :disabled="page === 1" @click="page--">
          <font-awesome-icon :icon="['fas', 'chevron-left']" class="icon-16" />
        </button>
        <button
          v-for="p in totalPages"
          :key="p"
          type="button"
          class="page-btn"
          :class="p === page ? 'page-btn-active' : 'page-btn-inactive'"
          @click="page = p"
        >
          {{ p }}
        </button>
        <button type="button" class="page-nav" :disabled="page === totalPages" @click="page++">
          <font-awesome-icon :icon="['fas', 'chevron-right']" class="icon-16" />
        </button>
      </div>

        </div>
      </div>
    </div>
    <ModalEditActionItem ref="modalEditAction" @saved="fetchActions" />
  </div>
</template>

<script>
import services from "@/http";
import { mapState, mapActions, mapGetters } from "vuex";
import ModalEditActionItem from "@/modules/strategic_plans/components/ShowTree/ModalEditActionItem.vue";
import PlanStructureTabs from "@/modules/strategic_plans/components/PlanStructureTabs.vue";

export default {
  name: "ActionsList",
  components: { ModalEditActionItem, PlanStructureTabs },
  data() {
    return {
      loading: false,
      error: null,
      actions: [],
      search: "",
      sortKey: "prazo",
      sortAsc: true,
      filtroStatus: "todos",
      filtroOrcamento: "todos",
      filtroResponsavel: "todos",
      prazoInicio: "",
      prazoFim: "",
      page: 1,
      perPage: 10,
    };
  },
  computed: {
    ...mapState("strategic_plans", {
      strategicPlan: "strategic_plan",
    }),
    ...mapGetters("strategic_plans", ["getTreePlanStructureLength", "getStructureDetailText"]),
    structureDetailText() {
      return this.getStructureDetailText || "";
    },
    actionBadges() {
      const list = this.actions || [];
      let concluded = 0;
      let inProgress = 0;
      let notStarted = 0;
      let delayed = 0;
      list.forEach((a) => {
        const s = this.normalizeStatus(a?.status);
        if (s === "finished") concluded++;
        else if (s === "delayed") delayed++;
        else if (s === "in-progress") inProgress++;
        else notStarted++;
      });
      return { concluded, inProgress, notStarted, delayed };
    },
    strategicPlanId() {
      const id = this.$route?.query?.strategicPlanId;
      if (id === undefined || id === null || id === "") return null;
      return String(id);
    },
    planIcon() {
      const icon = (this.strategicPlan?.icon || "").trim();
      if (!icon) return ["fas", "graduation-cap"];
      const normalized = icon.replace(/\s+/g, " ").trim().split(" ");
      const candidate = normalized.find((p) => p.startsWith("fa-"));
      const styleToken = normalized.find((p) =>
        ["fas", "far", "fal", "fab", "fad", "fat", "fa-solid", "fa-regular", "fa-light", "fa-brands", "fa-duotone", "fa-thin"].includes(p)
      );
      const iconName = (candidate || "").replace(/^fa-/, "");
      if (!iconName) return ["fas", "graduation-cap"];
      if (styleToken && styleToken.startsWith("fa-")) {
        const map = { "fa-solid": "fas", "fa-regular": "far", "fa-light": "fal", "fa-brands": "fab", "fa-duotone": "fad", "fa-thin": "fat" };
        return [map[styleToken] || "fas", iconName];
      }
      if (styleToken && ["fas", "far", "fal", "fab", "fad", "fat"].includes(styleToken)) return [styleToken, iconName];
      return ["fas", iconName];
    },
    planResponsibleText() {
      const r = this.strategicPlan?.responsible;
      const o = this.strategicPlan?.organizationalStructure;
      if (r && o) return `${r.name} / ${o.name}`;
      if (r) return r.name;
      return "Não definido";
    },
    planVigenciaText() {
      const start = this.strategicPlan?.start_term;
      const end = this.strategicPlan?.end_term;
      if (!start && !end) return "–";
      return [start, end]
        .filter(Boolean)
        .map((d) => this.$options.filters?.format_date?.(d) || d)
        .join(" a ");
    },
    hasPlanInstrumentoLegal() {
      const sp = this.strategicPlan;
      if (!sp) return false;
      const inst = String(sp.legal_instrument || "").trim();
      const link = String(sp.legal_instrument_link || "").trim();
      return !!(inst || sp.legal_instrument_date || link);
    },
    planInstrumentoText() {
      const inst = String(this.strategicPlan?.legal_instrument || "").trim();
      const date = this.strategicPlan?.legal_instrument_date;
      const y = date ? (this.$options.filters?.format_date?.(date, "YYYY") || date) : "";
      const text = [inst, y].filter(Boolean).join(" / ");
      if (text) return text;
      if (String(this.strategicPlan?.legal_instrument_link || "").trim()) return "Ver instrumento";
      return "–";
    },
    planLastUpdateText() {
      const u = this.strategicPlan?.updated_at;
      return u ? (this.$options.filters?.format_date?.(u) || u) : "–";
    },
    hasActiveFilters() {
      return (
        this.filtroResponsavel !== "todos" ||
        this.filtroStatus !== "todos" ||
        this.filtroOrcamento !== "todos" ||
        this.prazoInicio !== "" ||
        this.prazoFim !== ""
      );
    },
    responsaveisUnicos() {
      const list = [...(this.actions || [])];
      const names = new Set();
      list.forEach((a) => {
        const n = this.responsibleName(a);
        if (n && n !== "Não definido") names.add(n);
      });
      return Array.from(names)
        .sort((a, b) => a.localeCompare(b, "pt-BR"))
        .map((n) => ({ id: n, name: n }));
    },
    filteredSorted() {
      let list = [...(this.actions || [])];

      if (this.filtroResponsavel !== "todos") {
        if (this.filtroResponsavel === "sem_responsavel") {
          list = list.filter((a) => {
            const name = this.responsibleName(a);
            return !name || name === "Não definido";
          });
        } else {
          list = list.filter(
            (a) => this.responsibleName(a) === this.filtroResponsavel
          );
        }
      }

      if (this.filtroStatus !== "todos") {
        list = list.filter((a) => this.statusForFilter(a) === this.filtroStatus);
      }

      if (this.filtroOrcamento !== "todos") {
        list = list.filter((a) => {
          const previsto = a.orcamentoPrevisto ?? this.budgetTotalsForActionsList(a).planned;
          const executado = a.orcamentoExecutado ?? this.budgetTotalsForActionsList(a).executed;
          if (this.filtroOrcamento === "sem") return previsto === 0;
          if (this.filtroOrcamento === "dentro") return previsto > 0 && executado <= previsto;
          if (this.filtroOrcamento === "excedeu") return executado > previsto;
          return true;
        });
      }

      if (this.prazoInicio) {
        const min = new Date(this.prazoInicio).getTime();
        list = list.filter((a) => {
          const prazoVal = this.getPrazoValue(a);
          if (!prazoVal) return false;
          return new Date(prazoVal).getTime() >= min;
        });
      }

      if (this.prazoFim) {
        const max = new Date(this.prazoFim).getTime();
        list = list.filter((a) => {
          const prazoVal = this.getPrazoValue(a);
          if (!prazoVal) return false;
          return new Date(prazoVal).getTime() <= max;
        });
      }

      const q = (this.search || "").toLowerCase().trim();
      if (q) {
        list = list.filter((a) => {
          const titulo = (a.what || "").toLowerCase();
          const planoAcaoNome = (a.action_plan?.name || "").toLowerCase();
          const estruturaNome = (a.action_plan?.plan_structure?.name || "").toLowerCase();
          const responsavel = this.responsibleName(a).toLowerCase();
          return titulo.includes(q) || planoAcaoNome.includes(q) || estruturaNome.includes(q) || responsavel.includes(q);
        });
      }

      const dir = this.sortAsc ? 1 : -1;
      const sorters = {
        prazo: (a, b) => (this.deadlineTs(a) - this.deadlineTs(b)) * dir,
        status: (a, b) => (this.statusRankForSort(a) - this.statusRankForSort(b)) * dir,
        orcamento: (a, b) =>
          (this.budgetTotalsForActionsList(a).executed - this.budgetTotalsForActionsList(b).executed) * dir,
      };
      return list.slice().sort(sorters[this.sortKey] || sorters.prazo);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredSorted.length / this.perPage));
    },
    paginated() {
      const p = Math.min(this.page, this.totalPages);
      const start = (p - 1) * this.perPage;
      return this.filteredSorted.slice(start, start + this.perPage);
    },
  },
  watch: {
    search() {
      this.page = 1;
    },
    sortKey() {
      this.page = 1;
    },
    sortAsc() {
      this.page = 1;
    },
    filtroResponsavel() {
      this.page = 1;
    },
    filtroStatus() {
      this.page = 1;
    },
    filtroOrcamento() {
      this.page = 1;
    },
    prazoInicio() {
      this.page = 1;
    },
    prazoFim() {
      this.page = 1;
    },
  },
  methods: {
    ...mapActions("strategic_plans", [
      "ActionShow",
      "ActionLoadPlanStructure",
    ]),
    goToStructure() {
      if (this.strategicPlanId) {
        this.$router.push({
          name: "strategic_plans_show",
          params: { id: this.strategicPlanId },
        });
      }
    },
    toggleSort(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
        return;
      }
      this.sortKey = key;
      this.sortAsc = true;
    },
    clearFilters() {
      this.filtroResponsavel = "todos";
      this.filtroStatus = "todos";
      this.filtroOrcamento = "todos";
      this.prazoInicio = "";
      this.prazoFim = "";
      this.page = 1;
    },
    normalizeStatus(status) {
      const s = String(status || "").toLowerCase().trim();
      if (s === "finished" || s.includes("conclu")) return "finished";
      if (s === "in-progress" || s.includes("andamento") || s.includes("progress")) return "in-progress";
      if (s === "delayed" || s.includes("atras")) return "delayed";
      if (s === "cancelled" || s.includes("cancel")) return "cancelled";
      if (s === "stopped" || s.includes("paraliz")) return "stopped";
      if (s === "planned" || s.includes("planej")) return "planned";
      if (s === "" || s === "waiting") return "waiting";
      return "waiting";
    },
    /** Orçamento só do próprio item (linhas how_much). */
    budgetTotalsOwn(action) {
      const howMuchList = action?.action_plans_how_much || [];

      if (Array.isArray(howMuchList) && howMuchList.length) {
        const planned = howMuchList.reduce((acc, it) => acc + Number(it?.budget || 0), 0);
        const executed = howMuchList.reduce((acc, it) => acc + Number(it?.realized || 0), 0);
        return {
          planned: Number.isFinite(planned) ? planned : 0,
          executed: Number.isFinite(executed) ? executed : 0,
        };
      }

      const raw = action?.how_much;
      const scalar = Number(String(raw || "").replace(/[^\d.-]/g, ""));
      if (Number.isFinite(scalar) && scalar > 0) {
        return { planned: scalar, executed: scalar };
      }
      return { planned: 0, executed: 0 };
    },
    /**
     * Na lista de Ações: ação pai mostra o próprio orçamento; se vazio, soma das filhas diretas.
     * Subação continua só com o próprio.
     */
    budgetTotalsForActionsList(action) {
      if (action?.parent_id) {
        return this.budgetTotalsOwn(action);
      }
      const own = this.budgetTotalsOwn(action);
      if (own.planned > 0 || own.executed > 0) {
        return own;
      }
      const children = action.children || [];
      if (!Array.isArray(children) || !children.length) {
        return own;
      }
      return children.reduce(
        (acc, ch) => {
          const t = this.budgetTotalsOwn(ch);
          return {
            planned: acc.planned + t.planned,
            executed: acc.executed + t.executed,
          };
        },
        { planned: 0, executed: 0 }
      );
    },
    statusFromAction(action) {
      return this.normalizeStatus(action?.status);
    },
    statusForFilter(action) {
      return this.statusFromAction(action);
    },
    statusRankForSort(action) {
      const order = { waiting: 0, planned: 1, "in-progress": 2, delayed: 3, stopped: 4, cancelled: 5, finished: 6 };
      return order[this.statusFromAction(action)] ?? 0;
    },
    statusLabel(action) {
      const labels = {
        waiting: "Aguardando",
        planned: "Planejado",
        "in-progress": "Em progresso",
        delayed: "Atrasado",
        stopped: "Paralizado",
        cancelled: "Cancelado",
        finished: "Finalizado",
      };
      return labels[this.statusFromAction(action)] || "Aguardando";
    },
    statusDotClass(action) {
      const s = this.statusFromAction(action);
      const map = {
        waiting: "dot-waiting",
        planned: "dot-planned",
        "in-progress": "dot-info",
        delayed: "dot-danger",
        stopped: "dot-stopped",
        cancelled: "dot-cancelled",
        finished: "dot-success",
      };
      return map[s] || "dot-waiting";
    },
    statusBadgeClass(action) {
      const s = this.statusFromAction(action);
      const map = {
        waiting: "badge-waiting",
        planned: "badge-planned",
        "in-progress": "badge-info",
        delayed: "badge-danger",
        stopped: "badge-stopped",
        cancelled: "badge-cancelled",
        finished: "badge-success",
      };
      return map[s] || "badge-waiting";
    },
    completude(action) {
      const s = this.statusFromAction(action);
      const map = { finished: 100, "in-progress": 50, delayed: 30, stopped: 20, planned: 10, cancelled: 0, waiting: 0 };
      return map[s] ?? 0;
    },
    progressClass(action) {
      const s = this.statusFromAction(action);
      if (s === "finished") return "progress-success";
      if (s === "in-progress") return "progress-in-progress";
      if (s === "delayed") return "progress-danger";
      return "progress-muted";
    },
    budgetPlanned(action) {
      return this.budgetTotalsForActionsList(action).planned;
    },
    budgetExecuted(action) {
      return this.budgetTotalsForActionsList(action).executed;
    },
    isBudgetExceeded(action) {
      return this.budgetExecuted(action) > this.budgetPlanned(action);
    },
    hasBudget(action) {
      return this.budgetPlanned(action) > 0;
    },
    budgetPillClass(action) {
      if (!this.hasBudget(action)) return "pill-neutral";
      return this.isBudgetExceeded(action) ? "pill-danger" : "pill-success";
    },
    budgetPillLabel(action) {
      if (!this.hasBudget(action)) return "Sem orçamento";
      return this.isBudgetExceeded(action) ? "Excedeu o orçamento" : "Dentro do orçamento";
    },
    budgetPillIcon(action) {
      return ["fas", "dollar-sign"];
    },
    parseDate(value) {
      if (!value) return null;
      const str = String(value).trim();
      const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        const [, y, m, d] = match;
        const date = new Date(Number(y), Number(m) - 1, Number(d));
        if (!Number.isFinite(date.getTime())) return null;
        return date;
      }
      const d = new Date(value);
      if (!Number.isFinite(d.getTime())) return null;
      return d;
    },
    getPrazoValue(action) {
      return action?.when || action?.when_start || null;
    },
    startDate(action) {
      const val = action?.when_start ?? action?.prazo?.data_inicio ?? null;
      return this.parseDate(val);
    },
    deadlineDate(action) {
      const val = action?.when ?? action?.when_start ?? action?.prazo?.data_termino ?? null;
      return this.parseDate(val);
    },
    deadlineTs(action) {
      const d = this.deadlineDate(action);
      return d ? d.getTime() : Number.MAX_SAFE_INTEGER;
    },
    aggregateChildrenSchedule(action) {
      const children = action?.children || [];
      let minStart = null;
      let maxEnd = null;
      if (!Array.isArray(children)) return { minStart, maxEnd };
      for (const c of children) {
        const st = this.startDate(c);
        const en = this.deadlineDate(c);
        if (st && (!minStart || st.getTime() < minStart.getTime())) minStart = st;
        if (en && (!maxEnd || en.getTime() > maxEnd.getTime())) maxEnd = en;
      }
      return { minStart, maxEnd };
    },
    formatScheduleRange(start, end) {
      const fmt = (d) => (d ? d.toLocaleDateString("pt-BR") : null);
      const startStr = fmt(start);
      const endStr = fmt(end);
      if (startStr && endStr) return `${startStr} a ${endStr}`;
      if (endStr) return `até ${endStr}`;
      if (startStr) return `a partir de ${startStr}`;
      return "Sem cronograma";
    },
    /**
     * Subação: atraso pelo status ou pela data.
     * Ação pai: só pela data da própria ação (ou último fim entre filhas se a pai não tiver prazo);
     * não fica "atrasada" só porque uma filha está atrasada e o pai herdou status.
     */
    isScheduleLate(action) {
      const s = this.statusFromAction(action);
      if (s === "finished" || s === "cancelled") return false;

      if (action?.parent_id) {
        if (s === "delayed") return true;
        const d = this.deadlineDate(action);
        if (!d) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const due = new Date(d);
        due.setHours(0, 0, 0, 0);
        return due.getTime() < today.getTime();
      }

      const ownEnd = this.deadlineDate(action);
      if (ownEnd) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const due = new Date(ownEnd);
        due.setHours(0, 0, 0, 0);
        return due.getTime() < today.getTime();
      }

      const { maxEnd } = this.aggregateChildrenSchedule(action);
      if (!maxEnd) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const due = new Date(maxEnd);
      due.setHours(0, 0, 0, 0);
      return due.getTime() < today.getTime();
    },
    hasDisplaySchedule(action) {
      if (this.startDate(action) || this.deadlineDate(action)) return true;
      if (!action?.parent_id) {
        const { minStart, maxEnd } = this.aggregateChildrenSchedule(action);
        return !!(minStart || maxEnd);
      }
      return false;
    },
    schedulePillClass(action) {
      if (!this.hasDisplaySchedule(action)) return "pill-neutral";
      const s = this.statusFromAction(action);
      if (s === "finished") return "pill-success";
      if (s === "cancelled") return "pill-neutral";
      return this.isScheduleLate(action) ? "pill-danger" : "pill-success";
    },
    scheduleLabel(action) {
      const start = this.startDate(action);
      const end = this.deadlineDate(action);
      if (start || end) {
        return this.formatScheduleRange(start, end);
      }
      if (!action?.parent_id) {
        const { minStart, maxEnd } = this.aggregateChildrenSchedule(action);
        if (minStart || maxEnd) return this.formatScheduleRange(minStart, maxEnd);
      }
      return "Sem cronograma";
    },
    responsibleName(action) {
      if (action?.whoModel?.name) return action.whoModel.name;
      if (action?.who_model?.name) return action.who_model.name;
      if (typeof action?.who === "string" && action.who.trim()) return action.who.trim();
      return "Não definido";
    },
    responsibleTypeLabel(action) {
      const whoType = String(action?.who_type || "").toLowerCase();
      if (whoType.includes("organiz") || whoType.includes("org") || whoType.includes("structure")) return "Órgão";
      if (whoType.includes("person") || whoType.includes("people") || whoType.includes("physical")) return "Pessoa";
      return this.responsibleName(action) === "Não definido" ? "—" : "Pessoa";
    },
    responsibleIcon(action) {
      const label = this.responsibleTypeLabel(action);
      return label === "Órgão" ? ["fas", "building"] : ["fas", "user"];
    },
    breadcrumbText(action) {
      const level = 4;
      const parentName = action?.parent_id
        ? (action.parent_action?.what || action.parent_action?.name || this.parentActionName(action) || "Ação")
        : (action?.action_plan?.name || "").trim();
      return parentName ? `Nível ${level} - ${parentName}` : `Nível ${level} - Ação`;
    },
    parentActionName(action) {
      if (!action?.parent_id) return '';
      const parent = action.parent_action || this.actions?.find((a) => a.id === action.parent_id);
      return parent?.what || parent?.name || `#${action.parent_id}`;
    },
    parentAction(action) {
      if (!action?.parent_id) return null;
      return action.parent_action || this.actions?.find((a) => a.id === action.parent_id) || null;
    },
    formatCurrency(value) {
      const n = Number(value);
      const safe = Number.isFinite(n) ? n : 0;
      return safe.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 0,
      });
    },
    goToEdit(action) {
      if (!action?.id) return;
      this.$refs.modalEditAction?.show(action);
    },
    async fetchActions() {
      this.loading = true;
      this.error = null;
      try {
        // Source of truth for this page: GET /api/clients/actions
        // Keep optional filter by strategic plan when provided in querystring.
        const params = {};
        if (this.strategicPlanId) {
          params.strategic_plan_id = this.strategicPlanId;
          // backwards/compat param name (in case backend expects camelCase)
          params.strategicPlanId = this.strategicPlanId;
        }

        const { data } = await services.clients.actions(params);
        this.actions = Array.isArray(data?.actions) ? data.actions : [];
      } catch (e) {
        this.actions = [];
        this.error = "Não foi possível carregar as ações.";
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    this.fetchActions();
    if (this.strategicPlanId) {
      await this.ActionShow({ id: this.strategicPlanId });
      await this.ActionLoadPlanStructure();
    }
  },
};
</script>

<style scoped lang="scss">
.acoes-page-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  flex: 1 1 auto;
  min-width: 0;
}
.acoes-page {
  padding-bottom: 48px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.tree-panel {
  background: #fff;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  box-shadow: var(--shadow-card);
  padding: 1rem;
}
.tree-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.acoes-main {
  display: block;
  width: 100%;
}
.bg-background {
  background-color: var(--background);
}
.text-foreground {
  color: var(--foreground);
}
.text-muted-foreground {
  color: var(--muted-foreground);
}
.min-h-screen {
  min-height: 100vh;
}
.max-w-7xl {
  max-width: 1280px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.px-4 {
  padding-left: 16px;
  padding-right: 16px;
}
.py-3 {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-6 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.pt-4 {
  padding-top: 16px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 4px;
}
.mr-2 {
  margin-right: 8px;
}
.ml-1 {
  margin-left: 4px;
}
.ml-2 {
  margin-left: 8px;
}
.mx-2 {
  margin-left: 8px;
  margin-right: 8px;
}
.mx-3 {
  margin-left: 12px;
  margin-right: 12px;
}
.pl-5 {
  padding-left: 20px;
}

.text-xs {
  font-size: 12px;
}
.text-sm {
  font-size: 14px;
}
.text-10 {
  font-size: 10px;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.uppercase {
  text-transform: uppercase;
}
.tracking-wider {
  letter-spacing: 0.08em;
}

.icon-16 {
  height: 16px;
  width: 16px;
}
.icon-14 {
  height: 14px;
  width: 14px;
}
.icon-12 {
  height: 12px;
  width: 12px;
}
.icon-10 {
  height: 10px;
  width: 10px;
}

.search-wrap {
  position: relative;
  flex: 1 1 auto;
  max-width: 20rem;
}
.search-wrap-inline {
  max-width: 22rem;
}
.search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
  font-size: 0.875rem;
}
.search-input {
  width: 100%;
  padding: 0.625rem 0.75rem 0.625rem 2.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  background: #fff;
  font-size: 0.875rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.search-input::placeholder {
  color: #9ca3af;
}
.search-input:focus {
  outline: none;
  border-color: rgba(var(--primary-rgb), 0.4);
  box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.15);
}

.pill {
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: var(--muted-foreground);
  margin-right: 8px;
}
.icon-sort {
  height: 12px;
  width: 12px;
}
.pill:hover {
  color: var(--foreground);
  border-color: rgba(36, 52, 71, 0.3);
}
.pill-active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.pill-inactive {
  background: transparent;
}

.sort-bar {
  padding-top: 24px;
  padding-bottom: 16px;
  gap: 8px;
}

.filter-bar {
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--card);
  padding: 16px;
  margin-bottom: 24px;
}
.filter-bar-inner {
  gap: 12px;
}
.filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.filter-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--muted-foreground);
}
.filter-input {
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--background);
  padding: 6px 12px;
  font-size: 12px;
  color: var(--foreground);
  outline: none;
}
.filter-input:focus {
  border-color: rgba(var(--primary-rgb), 0.4);
  box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.12);
}
.filter-select {
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--background);
  padding: 6px 12px;
  font-size: 12px;
  color: var(--foreground);
  outline: none;
}
.filter-select:focus {
  border-color: rgba(var(--primary-rgb), 0.4);
  box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.12);
}
.filter-select-status {
  min-width: 140px;
}
.filter-select-orcamento {
  min-width: 160px;
}
.filter-group-responsavel {
  max-width: 200px;
  min-width: 0;
  flex: 0 1 200px;
}
.filter-select-responsavel {
  min-width: 0;
  max-width: 100%;
  width: 100%;
}
.filter-divider {
  height: 32px;
  width: 1px;
  background: var(--border);
  align-self: center;
}
.btn-clear-filters {
  background: transparent;
  border: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--primary);
  cursor: pointer;
  padding: 0;
}
.btn-clear-filters:hover {
  opacity: 0.8;
}

.space-y-3 > * + * {
  margin-top: 12px;
}

.empty-state {
  flex: 1 1 auto;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

.action-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--card);
  overflow: hidden;
  box-shadow: var(--shadow-card);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.action-card:hover {
  box-shadow: var(--shadow-elevated);
  transform: translateY(-1px);
}

.min-w-0 {
  min-width: 0;
}
.flex-1 {
  flex: 1;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-dot {
  height: 10px;
  width: 10px;
  border-radius: 999px;
  flex-shrink: 0;
  background: var(--muted-foreground);
}
.dot-waiting {
  background: var(--muted-foreground);
}
.dot-planned {
  background: var(--status-info, #3b82f6);
}
.dot-info {
  background: #2563eb;
}
.dot-danger {
  background: var(--status-danger, #ef4444);
}
.dot-stopped {
  background: #f97316;
}
.dot-cancelled {
  background: #6b7280;
}
.dot-success {
  background: var(--status-success);
}

.action-card .breadcrumb {
  opacity: 0.9;
  padding-left: 0;
  margin-left: 0;
  margin-bottom: 0;
  text-align: left;
}
.action-card .breadcrumb::before {
  display: none;
}
.action-card--sub {
  border-color: rgba(59, 130, 246, 0.3);
}
.sub-action-corner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 600;
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.08);
  border-bottom: 1px solid rgba(59, 130, 246, 0.12);
  border-radius: 12px 12px 0 0;
}
.parent-action-label {
  display: flex;
  align-items: center;
  gap: 6px;
}
.parent-action-edit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: #3b82f6;
  border-radius: 6px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease;
}
.parent-action-wrap:hover .parent-action-edit-btn {
  opacity: 1;
}
.parent-action-edit-btn:hover {
  background: rgba(59, 130, 246, 0.15);
}
.sub-action-corner-icon {
  font-size: 10px;
  transform: rotate(90deg);
  opacity: 0.7;
}

.status-badge {
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.badge-waiting {
  background: rgba(107, 114, 128, 0.15);
  color: var(--muted-foreground);
}
.badge-planned {
  background: var(--status-info-bg, rgba(59, 130, 246, 0.12));
  color: var(--status-info, #3b82f6);
}
.badge-info {
  background: rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
}
.badge-danger {
  background: var(--status-danger-bg, rgba(239, 68, 68, 0.12));
  color: var(--status-danger, #ef4444);
}
.badge-stopped {
  background: rgba(249, 115, 22, 0.12);
  color: #ea580c;
}
.badge-cancelled {
  background: rgba(107, 114, 128, 0.12);
  color: #6b7280;
}
.badge-success {
  background: var(--status-success-bg);
  color: var(--status-success);
}

.indicators {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 24px;
}
@media (min-width: 576px) {
  .indicators {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 32px;
  }
}

.indicator {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.indicator--responsible {
  min-width: 0;
}
.indicator-responsible-name,
.indicator-responsible-type {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.indicator-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: var(--muted-foreground);
  text-transform: uppercase;
  margin-bottom: 8px;
  order: 0;
}

.progress-bar {
  height: 8px;
  width: 5.5rem;
  min-width: 5.5rem;
  border-radius: 999px;
  background: var(--muted);
  overflow: hidden;
}
.progress-inner {
  height: 100%;
  transition: width 0.5s ease;
}
.progress-success {
  background: var(--status-success);
}
.progress-in-progress {
  background: #2563eb;
}
.progress-danger {
  background: var(--status-danger, #ef4444);
}
.progress-muted {
  background: rgba(109, 119, 134, 0.4);
}
.percent {
  min-width: 32px;
  text-align: right;
  margin-left: 10px;
}

.budget-pill,
.schedule-pill {
  margin-top: 6px;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  order: 2;
  /* don't stretch to full width inside flex column */
  align-self: flex-start;
  width: fit-content;
}
.pill-success {
  background: var(--status-success-bg);
  color: var(--status-success);
}
.pill-danger {
  background: var(--status-danger-bg);
  color: var(--status-danger);
}
.pill-neutral {
  background: var(--status-neutral-bg);
  color: var(--status-neutral);
}

.quick-actions {
  border-top: 1px solid var(--border);
  padding: 10px 20px;
  background: rgba(238, 241, 244, 0.25);
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.qa-btn {
  border: 0;
  background: transparent;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--muted-foreground);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background 0.15s ease, color 0.15s ease;
}
.qa-btn:hover {
  background: var(--muted);
  color: var(--foreground);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-bottom: 24px;
}
.page-nav {
  border: 1px solid var(--border);
  background: transparent;
  border-radius: 999px;
  padding: 6px 10px;
  color: var(--muted-foreground);
}
.page-nav:disabled {
  opacity: 0.3;
  pointer-events: none;
}
.page-btn {
  height: 32px;
  width: 32px;
  border-radius: 999px;
  border: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}
.page-btn-active {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.page-btn-inactive {
  background: transparent;
  color: var(--muted-foreground);
}
.page-btn-inactive:hover {
  background: var(--muted);
}

/* ===== Main content area (aligned with strategic_plans/Show) ===== */
.show-main-content {
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  padding: 1.5rem 1rem;
}

/* ===== Plan header card ===== */
.plan-header-card {
  background: #343a40;
  border-radius: 0.75rem;
  color: #fff;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15);
  margin-bottom: 0.5rem;
}
.plan-header-top {
  gap: 1.5rem;
  align-items: flex-start;
}
.plan-header-left {
  flex-shrink: 1;
  min-width: 0;
}
.plan-icon-wrap {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.plan-icon {
  font-size: 2rem;
  color: #fff;
}
.plan-header-title-area {
  min-width: 0;
  padding-top: 0.125rem;
}
.plan-title {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  margin: 0;
  color: #fff;
}
@media (min-width: 576px) {
  .plan-title {
    font-size: 1.5rem;
  }
}

.plan-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem 2.5rem;
  flex: 1;
}
.plan-meta-grid-desktop {
  display: none;
}
.plan-meta-grid-mobile {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem 1.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.plan-meta-label {
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  opacity: 0.7;
  display: block;
}
.plan-meta-value {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin: 0.125rem 0 0 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}
.plan-meta-icon {
  font-size: 0.875rem;
  opacity: 0.7;
}


.plan-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
}
.btn-plan-edit {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.875rem;
  border-radius: 0.5rem;
  background: #0d6efd;
  border: 1px solid rgba(13, 110, 253, 0.9);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
}
.btn-plan-edit:hover {
  background: rgba(13, 110, 253, 0.9);
  color: #fff;
  text-decoration: none;
  box-shadow: 0 6px 14px rgba(13, 110, 253, 0.25);
}

/* ===== Counter cards ===== */
.counters-row {
  margin-top: 0.25rem;
}
.counter-card {
  background: #fff;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  box-shadow: var(--shadow-card);
  padding: 1.25rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.15s;
}
.counter-card-clickable {
  cursor: pointer;
}
.counter-card-clickable:hover {
  background: #f9fafb;
  border-color: rgba(var(--primary-rgb), 0.3);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.06);
}
.counter-card-highlight {
  border-color: rgba(var(--primary-rgb), 0.25);
  background: rgba(var(--primary-rgb), 0.03);
}
.counter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--muted-foreground, #6b7280);
  letter-spacing: 0.04em;
  display: block;
}
.counter-value {
  font-size: 1.875rem;
  font-weight: 500;
  color: var(--foreground, #1f2937);
  margin-top: 0.375rem;
  font-family: var(--font-heading, 'Inter', 'Roboto', sans-serif);
}
.counter-link {
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--primary);
  margin-top: 0.375rem;
  display: inline-block;
}

@media (min-width: 768px) {
  .plan-meta-grid-desktop {
    display: grid;
  }
  .plan-meta-grid-mobile {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .search-wrap {
    max-width: none;
  }
  .tree-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .plan-header-card {
    padding: 1.25rem 1rem;
  }
  .plan-header-top {
    flex-wrap: wrap;
  }
}
</style>
